import React from "react";
import { Box, Typography, Card, Container } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";

const InvesterCards = () => {
  const { language, toggleLanguage, translations } = useLanguage();
  return (
    <Box sx={{ padding: { xs: " 35px", md: "5rem 5.5rem" } }}>
      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "stretch",
          justifyContent: "space-between",
          borderRadius: "20px",
          boxShadow: "none",
          width: "100%",
          height: "180px",
          overflow: "hidden",
          position: "relative", // for image layering

          border: "1.5px solid rgba(25, 171, 226, 1)",
          background: "linear-gradient(90deg, #F2F9FC 0%, #FFFFFF 100%)", // smoother light gradient
        }}
      >
        {/* Left: Text */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            pl: 4,
            pr: 3,
            pt: { xs: 0, sm: 0, md: 0, lg: 0 },
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: "500", color: "rgba(26, 28, 30, 1)" }}
          >
        
            {translations[language]?.investTitle}
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "500", color: "rgba(26, 28, 30, 1)",lineHeight:"28.33px" }}
          >
          {translations[language]?.investTitles}
          </Typography>
        </Box>

        {/* Right: Image that stretches fully */}
        <Box
          component="img"
          src="/Images/blueNet.png"
          alt="Decorative Wave"
          sx={{
            height: "100%", // takes full height of card
            width: { xs: "100%", sm: "80%", md: "400px" },
            objectFit: "cover", // fills space while preserving aspect ratio
            borderTopRightRadius: "18px",
            display:{xs:"none",md:"flex"},
            borderBottomRightRadius: "18px",
          }}
        />
      </Card>
    </Box>
  );
};

export default InvesterCards;
